export const GREPTCHA_KEY = '6Le91nskAAAAAPJMsjjjbQA3Ag6U79T1ICfXai3F';

export default function getToken(action = 'submit') {
  return new Promise((resolve) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(GREPTCHA_KEY, { action }).then(resolve);
    });
  });
}